import { useEffect, useState } from 'react'
import Footer from '../../Components/Footer'
import HomeSlider from './Components/HomeSlider'
import SupplierSlider from './Components/SupplierSlider'
import useGetLogosAndSliderItems from './Hooks/useGetLogosAndSliderItems'
import { useShop } from '../../Providers/ShopProvider'
import { ImageComponent } from './Components/HomePageAfterSelectCategory'
import { useNavigate } from 'react-router-dom'
import { FaArrowRight } from "react-icons/fa"
import { useMediaQuery } from 'react-responsive'

import './Styles/HomePageIndexStyles.css'
import { useParams } from '../../Providers/ParamsProvider'

const HomePageIndex = () => {
    const navigate = useNavigate()
    const { setProductsFilter, clearProductsFilter } = useShop()
    const { categoriesForHomePage, isLoadingCategoriesForHomePage, setActiveCategory, setShowFeatureListFilter } = useShop()
    const { HomeSliderItems, SuppliersLogo } = useGetLogosAndSliderItems()
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedSubcategory, setSelectedSubcategory] = useState(null)
    const [selectedCat3, setSelectedCat3] = useState(null)
    const { isMobile } = useParams()

    useEffect(() => {
        clearProductsFilter(null, false)
    }, [])
    useEffect(() => {
        setSelectedSubcategory(null)
    }, [selectedCategory])

    const handleCategoryFeatureClick = (category, isLevel1) => {
        setActiveCategory(category)
        setShowFeatureListFilter(true)
        if (isLevel1) {
            navigate('/CategoryDetails')
        }
        else {
            navigate('/shop')
        }
    }
    const handleClearCategoryData = () => {
        setSelectedCategory(null)
        setSelectedSubcategory(null)
        setSelectedCat3(null)
    }
    const handleFilterClick = (name) => {
        setProductsFilter(prev => ({
            ...prev,
            [name]: true
        }))
        navigate('/shop')
    }

    return (
        <div className="container-fluid">
            <div className="row" onMouseLeave={handleClearCategoryData}>
                {isMobile ?
                    <>
                        <div className="col-12 mt-3">
                            <div style={{ position: 'relative' }}>
                                <HomeSlider homeSliderItems={HomeSliderItems} />
                            </div>
                        </div>
                        <div className="col-12">
                            <CategoriesSection
                                selectedCategory={selectedCategory}
                                setSelectedCategory={setSelectedCategory}
                                categoriesForHomePage={categoriesForHomePage}
                                isLoadingCategoriesForHomePage={isLoadingCategoriesForHomePage}
                                handleCategoryFeatureClick={handleCategoryFeatureClick}
                            />
                            <div className='mt-2 ms-3 d-flex flex-column'>
                                <span className='mb-3 home-page-availability-filter' onClick={() => handleFilterClick('IsSellOut')}>Wyprzedaż</span>
                                <span className='mb-3 home-page-availability-filter' onClick={() => handleFilterClick('IsPromo')}>Promocje</span>
                                <span className='home-page-availability-filter' onClick={() => handleFilterClick('IsNew')}>Nowości</span>
                            </div>
                        </div>
                    </> :
                    <>
                        <div className="col-12 col-xl-5 col-xxl-4">
                            <CategoriesSection
                                selectedCategory={selectedCategory}
                                setSelectedCategory={setSelectedCategory}
                                categoriesForHomePage={categoriesForHomePage}
                                isLoadingCategoriesForHomePage={isLoadingCategoriesForHomePage}
                                handleCategoryFeatureClick={handleCategoryFeatureClick}
                            />
                            <div className='mt-5 ms-5 d-flex flex-column'>
                                <span className='mb-3 home-page-availability-filter' onClick={() => handleFilterClick('IsSellOut')}>Wyprzedaż</span>
                                <span className='mb-3 home-page-availability-filter' onClick={() => handleFilterClick('IsPromo')}>Promocje</span>
                                <span className='home-page-availability-filter' onClick={() => handleFilterClick('IsNew')}>Nowości</span>
                            </div>
                        </div>
                        <div className="col-12 col-xl-7 col-xxl-8 mt-5">
                            <div style={{ position: 'relative', paddingRight: '3.5%' }}>
                                <HomeSlider homeSliderItems={HomeSliderItems} />
                                <CategoryPopup
                                    selectedCategory={selectedCategory}
                                    handleCategoryFeatureClick={handleCategoryFeatureClick}
                                    selectedSubcategory={selectedSubcategory}
                                    setSelectedSubcategory={setSelectedSubcategory}
                                    selectedCat3={selectedCat3}
                                    setSelectedCat3={setSelectedCat3}
                                />
                            </div>
                        </div>
                    </>
                }
            </div>
            <SupplierSlider supplierLogoItems={SuppliersLogo} />
            <Footer />
        </div>)

}

const CategoryPopup = ({ selectedCategory, handleCategoryFeatureClick, selectedSubcategory, setSelectedSubcategory, selectedCat3, setSelectedCat3 }) => {
    const blockComponent = useMediaQuery({ maxWidth: 1300 })

    if (!selectedCategory || selectedCategory.subCategories.length === 0 || blockComponent) {
        return null
    }
    return (
        <div className='home-page-category-popup'>
            <div className="row">
                <div className="col-auto d-flex flex-column me-4">
                    <b className='mb-4'>{selectedCategory.catDescription}</b>
                    {selectedCategory.subCategories.map((category, key) => (
                        <div className='d-flex'>
                            <span className={`mb-1 ${selectedSubcategory && category.catDescription === selectedSubcategory.catDescription ? 'home-page-selected-category' : ''}`} style={{ cursor: 'pointer' }}
                                key={key} onMouseEnter={() => { setSelectedSubcategory(category) }} onClick={() => handleCategoryFeatureClick(category, false)}>{category.catDescription}</span>
                            <span className={`ms-2 ${selectedSubcategory && category.catDescription === selectedSubcategory.catDescription ? 'home-page-selected-category' : 'secondary-color-text'}`}>{`(${category.artCount})`}</span>
                        </div>
                    ))}
                </div>
                {selectedSubcategory && selectedSubcategory.subCategories.length > 0 ? (
                    <>
                        <div className="col-auto">
                            <FaArrowRight />
                        </div>
                        <div className="col-auto d-flex flex-column">
                            <b className='mb-4'>{selectedSubcategory.catDescription}</b>
                            {selectedSubcategory.subCategories.map((category, key) => (
                                <div className='d-flex'>
                                    <span className={`mb-1 ${selectedCat3 && selectedCat3.catDescription === category.catDescription ? 'home-page-selected-category' : ''}`} key={key} style={{ cursor: 'pointer' }}
                                        onMouseEnter={() => { setSelectedCat3(category) }} onClick={() => handleCategoryFeatureClick(category, false)}>{category.catDescription}</span>
                                    <span className={`ms-2 ${selectedCat3 && selectedCat3.catDescription === category.catDescription ? 'home-page-selected-category' : 'secondary-color-text'}`}> {`(${category.artCount})`}</span>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (null)}
            </div>
        </div>
    )
}

const CategoriesSection = ({ selectedCategory, setSelectedCategory, categoriesForHomePage, isLoadingCategoriesForHomePage, handleCategoryFeatureClick }) => {
    if (isLoadingCategoriesForHomePage) {
        return (
            <p class="card-text placeholder-glow mt-2 ms-2 mt-xxl-5 ms-xxl-5">
                <span class="placeholder col-7"></span>
                <span class="placeholder col-4"></span>
                <span class="placeholder col-4"></span>
                <span class="placeholder col-6"></span>
                <span class="placeholder col-8"></span>

                <span class="placeholder col-7"></span>
                <span class="placeholder col-4"></span>
                <span class="placeholder col-4"></span>
                <span class="placeholder col-6"></span>
                <span class="placeholder col-8"></span>
            </p>
        )
    }
    return (
        <div className='mt-3 ms-2 mt-xxl-5 ms-xxl-5'>
            {categoriesForHomePage.map((category, index) => {
                const subcategories = category.subCategories.slice(0, 3).map(sc => sc.catDescription).join(', ');
                const subCategoryText = category.subCategories.length > 1 ? `${subcategories}...` : subcategories;
                return (
                    <div className="row mt-2 d-flex align-items-center" key={index} style={{ cursor: 'pointer' }} onClick={() => handleCategoryFeatureClick(category, true)}
                        onMouseEnter={() => { setSelectedCategory(category) }}>
                        <div className="col-2">
                            <ImageComponent
                                path={category.catFileName}
                            />
                        </div>
                        <div className="col d-flex flex-column">
                            <div className='d-flex align-items-center'>
                                <b className={selectedCategory && selectedCategory.catDescription === category.catDescription ? 'home-page-selected-category' : ''}>{category.catDescription}</b>
                                <span className={selectedCategory && selectedCategory.catDescription === category.catDescription ? 'home-page-selected-category ms-2' : 'secondary-color-text ms-2'}>{`(${category.artCount})`}</span>
                            </div>
                            <div className='d-flex align-items-center'>
                                <span className='secondary-color-text'>{subCategoryText}</span>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>)
}

export default HomePageIndex